var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.9,
    height: 11.016,
    viewBox: "0 0 9.9 11.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".password{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.1 -1.2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "password",
    d: "M14.4,5.744h-.462V4.087a2.887,2.887,0,0,0-5.773,0V5.744H7.7a1.607,1.607,0,0,0-1.6,1.6v3.27a1.607,1.607,0,0,0,1.6,1.6h6.7a1.607,1.607,0,0,0,1.6-1.6V7.345A1.6,1.6,0,0,0,14.4,5.744ZM8.84,4.087a2.2,2.2,0,1,1,4.409-.011V5.733H8.84Zm6.472,6.529a.917.917,0,0,1-.913.913H7.69a.917.917,0,0,1-.913-.913V7.345a.917.917,0,0,1,.913-.913h6.7a.917.917,0,0,1,.913.913Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.6a4e76ee.svg";
export { ForwardRef as ReactComponent };